import Facebook from "../images/Facebook.png"
import Instagram from "../images/ico-instagram.png"
import Twitter from "../images/icons/ico-twitter.png"

import Logo from "../images/logo.svg"

export const LOGO = Logo
export const Footer_Menu = {
  company: [
    { ID: 1, title: "About", slug: "about" },
    { ID: 2, title: "Privacy Policy", slug: "privacy-policy" },
    { ID: 3, title: "Terms & Conditions", slug: "tac" },
  ],
  platform: [
    { ID: 1, title: "For Companies", slug: "for-companies" },
    { ID: 2, title: "For Candidates", slug: "for-candidates" },
  ],
  "contact information": [
    { ID: 1, title: "Mahadevsthan, Koteshwor, Kathmandu, Nepal" },
    { ID: 2, title: "Phone: +977 01-4155216", href: "tel:+977-01-4155216" },
    {
      ID: 3,
      title: "Email: hi@wdnexus.com ",
      href: "mailto:hi@wdnexus.com ",
    },
  ],
}

export const Footer_Social = [
  {
    network_icon: `<Image src=${Facebook} alt="wdn-facebook-logo" />`,
    network_url: "https://www.facebook.com/workersdirectorynexus",
  },
  {
    network_icon: `<Image src=${Instagram} alt="wdn-facebook-logo" />`,
    network_url: "https://www.instagram.com/wdnexus/",
  },
  {
    network_icon: `<Image src=${Twitter} alt="wdn-facebook-logo" />`,
    network_url: "https://www.twitter.com/workersnexus/",
  },
]

export const Footer_Description = ` <div class="mt-3">
    <span class="footer-section__motto">
      WDN &#8211; A simple and effective way to connect Companies with
      Candidates.
    </span>
  </div>`

export const Footer_Copyright = `<p>© <strong>WDN</strong>, All Rights Reserved. Developed by <a href="https://www.codepros.com.np" target="_blank" rel="noreferrer"><strong>Codepros</strong></a></p>`
